import { render, staticRenderFns } from "./PriceArchitecture.vue?vue&type=template&id=7f3813ff&scoped=true&"
import script from "./PriceArchitecture.vue?vue&type=script&lang=js&"
export * from "./PriceArchitecture.vue?vue&type=script&lang=js&"
import style0 from "./PriceArchitecture.vue?vue&type=style&index=0&id=7f3813ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3813ff",
  null
  
)

export default component.exports